// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__GQ6DM","containerItemsCenter":"Skeleton_containerItemsCenter__1BtKs"};